import { KIZEN_PREFIX } from 'storage';

import { SessionStorage } from './SessionStorage';
export const KEEP_ALIVE_LAST_ACTIVITY_KEY = `${KIZEN_PREFIX}keep-alive-last-activity`;
export const keepAliveLastActivitySessionStorage = new SessionStorage(
  KEEP_ALIVE_LAST_ACTIVITY_KEY
);
